module.exports = __webpack_public_path__ + "static/img/sprite2310.854f85e.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/sprite2310.png
// module id = 2+89
// module chunks = 7